import { createContext, useContext, useState, type ReactNode } from "react";
import { currentUser as initialUser, type User, type Role } from "./mock-data";

interface AppStore {
  user: User | null;
  setUser: (u: User | null) => void;
  role: Role;
  setRole: (r: Role) => void;
}

const Ctx = createContext<AppStore | null>(null);

export function AppStoreProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(initialUser);
  const [role, setRoleState] = useState<Role>(initialUser.role);

  const setRole = (r: Role) => {
    setRoleState(r);
    if (user) setUser({ ...user, role: r });
  };

  return (
    <Ctx.Provider value={{ user, setUser, role, setRole }}>{children}</Ctx.Provider>
  );
}

export function useAppStore() {
  const v = useContext(Ctx);
  if (!v) throw new Error("useAppStore must be used inside AppStoreProvider");
  return v;
}
